import { FuseAnimate, FusePageCarded } from '@fuse';
import _ from '@lodash';
import { Input, Paper, Typography, withStyles } from '@material-ui/core';
import CatchErro from 'app/Core/Components/CatchErro/CatchErro';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as AppActions from 'app/store/actions';
import withReducer from 'app/store/withReducer';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { MdShoppingCart } from 'react-icons/md';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import MarketplaceDialog from './MarketplaceDialog';
import MarketplaceList from './MarketplaceList';
import * as Actions from './Store/Actions/MarketplaceActions';
import reducer from './Store/Reducers/MarketplaceReducer';

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    root: {
        background: theme.palette.type === 'dark' ? '#424242' : '#E6E6E6',
        color: theme.palette.primary.contrastText
    },
    paper: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '20px',
        width: '75%'
    },
});

class MarketplaceApp extends XAPPComponent {

    state = {
        open: null,
        filtro: "",
    };

    componentDidMount() {
        this.props.getListaIntegracoes();
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    openDialog = (_AValue = null) => {
        this.setState(_.set({ ...this.state }, "open", _AValue));
    }

    getIntegracoes = () => {
        const { integracoes = null } = this.props;
        let AResponse = [];
        if (!_.isNull(integracoes)) {
            AResponse = integracoes;
        }
        return AResponse;
    }

    render() {
        const { classes, integracoes = null, user, location } = this.props;
        const xappRouteParams = this.props.match.params;
        const form = this.state;
        return (
            <React.Fragment>
                <CatchErro
                    url={this.props.match.url}
                >
                    <FusePageCarded
                        classes={{
                            contentWrapper: "p-0",
                            contentCardWrapper: "p-16 sm:p-24 pb-80",
                            leftSidebar: "w-256 border-0",
                            header: "w-full min-h-48 h-48 max-h-48 flex",
                            topBg: "min-h-48 h-48"
                        }}
                        header={
                            <div className="w-full flex items-center">
                                <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                    <Typography className="flex text-white items-center" variant="h6">
                                        <MdShoppingCart className="text-24 text-white mx-8" />
                                        {"Marketplace"}
                                    </Typography>
                                </FuseAnimate>
                            </div>
                        }
                        contentToolbar={
                            <div className="flex w-full items-center justify-center">
                                <Paper component="div" className={classes.paper}>
                                    <Input
                                        placeholder="Filtrar"
                                        className="flex w-full pl-12 py-4"
                                        disableUnderline
                                        fullWidth
                                        autoFocus
                                        name="nome"
                                        value={form.filtro}
                                        type='text'
                                        autoComplete="off"
                                        inputProps={{
                                            'aria-label': 'Filtar produtos'
                                        }}
                                        onChange={this.handleChange}
                                    />
                                </Paper>
                            </div>
                        }
                        content={
                            <MarketplaceList
                                integracoes={this.getIntegracoes()}
                                openDialog={this.openDialog}
                                xappRouteParams={xappRouteParams}
                            />
                        }
                        onRef={instance => {
                            this.pageLayout = instance;
                        }}
                        sidebarInner
                        innerScroll
                    />
                    {!_.isNull(integracoes) &&
                        <MarketplaceDialog
                            xappRouteParams={xappRouteParams}
                            open={form.open}
                            openDialog={this.openDialog}
                        />
                    }
                </CatchErro>
            </React.Fragment>

        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getListaIntegracoes: Actions.getListaIntegracoes,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ fuse, auth, Marketplace }) {
    return {
        integracoes: Marketplace.integracoes,
        theme: fuse.settings.mainTheme,
        user: auth.user.data,
    }
}

export default withReducer('Marketplace', reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(MarketplaceApp))));
